import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { 
  listPropertyResaleVibe,
  updatePropertyResaleVibeStatus 
} from "../../Redux/Actions/propertyResaleVibeActions";
import "./listPropertyResaleVibe.css";
import { columnsPropertyResaleVibeList } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListPropertyResaleVibe = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");

  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
    const vibeData = {
      page,
      limit: pageSize,
      is_deleted: false,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(listPropertyResaleVibe(vibeData, showLoader));

      if (!showLoader) {
        toast.success("Vibe list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh vibe list");
      }
    }
  }, [dispatch, debouncedSearch, dateRange]);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [fetchDetails, pagination.current, pagination.pageSize]);

  const { vibes, loading } = useSelector((state) => state.propertyResaleVibe);
  console.log("vibe data", vibes);

  useEffect(() => {
    if (vibes?.total) {
      setPagination((prevData) => ({ ...prevData, total: vibes.total }));
    }
  }, [vibes]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  // Status update handler for columns
  const handleStatusUpdate = async (id) => {
    try {
      const vibe = vibes?.data?.find((item) => item._id === id);
      const statusData = {
        vibeId: id,
        status: vibe?.status === "active" ? "inactive" : "active",
      };
      
      await dispatch(updatePropertyResaleVibeStatus(statusData));
      toast.success("Status updated successfully");
      fetchDetails(pagination.current, pagination.pageSize, false);
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  // Edit modal handler for columns
  const openEditModal = (record) => {
    window.location.href = `/resale_vibe/edit/${record._id}`;
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  // Pass pagination params to columns helper
  const columns = columnsPropertyResaleVibeList(
    pagination.current,
    pagination.pageSize,
    handleStatusUpdate,
    openEditModal,
    canEdit
  );

  return (
    <MainLayout>
      <div className="dashboard-container">
        <div className="table_component_all">
          <ListTopSearch
            buttonhead={canAdd ? "Add Resale Vibe" : null}
            navigateTo={canAdd ? "/resale_vibe/add" : null}
            h3heading="Property Resale Vibe List"
            setState={setSearchQuery}
            onCalendarClick={() => setIsDatePopupVisible(true)}
          />
          <div style={{ overflowX: "auto", padding: "0px 60px" }}>
            <Table
              dataSource={Array.isArray(vibes?.data) ? vibes.data : []}
              pagination={pagination}
              scroll={{ x: 1700, y: 500 }}
              onChange={handleTableChange}
              loading={loading}
              columns={columns}
              rowClassName={() => "text-center"}
            />
          </div>
        </div>
        <DateRangePopup
          visible={isDatePopupVisible}
          initialStart={dateRange.start}
          initialEnd={dateRange.end}
          onCancel={() => setIsDatePopupVisible(false)}
          onOk={handleDateRangeApply}
        />
      </div>
    </MainLayout>
  );
};

export default ListPropertyResaleVibe;